import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import { TIMEOUT_STORE, TIMESTAMP_MULTIPLY } from 'util/constants';

module.exports = {
    createFetchParams: (period, pagination, sortBy, filters, download = 0) => ({
        date:          Math.floor(period.startDate / TIMESTAMP_MULTIPLY),
        technology:    filters.storageTechnology,
        ordering:      sortBy,
        page:          pagination.page,
        page_size:     pagination.pageSize,
        column_filter: filters.search ? filters.columnFilter : null,
        value_filter:  filters.search,
        download
    }),
    ...storeModuleFactory({
        name:               'storageDetail',
        endpoint:           endpoints.storage.storageDetail,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        transformResultsFn: response => {
            if (response.results) {
                return response.results.map(item => ({
                    ibx:           item.ibx,
                    replicaType:   item.replica_type,
                    volumenName:   item.volumen_name,
                    assignedSpace: item.assigned_space,
                    usedSpace:     item.used_space,
                    descPoe:       item.desc_poe,
                    serviceName:   item.service_name
                }));
            }

            return []
        }
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/storageDetail.js